/**
 * @deprecated use same function from '@felce/lowcode-utils' instead
 */
export function isProjectSchema(data: any): boolean {
  return data && data.componentsTree;
}
